module.exports = __webpack_public_path__ + "e7a02b09.svg";